import React, { useEffect } from "react";
import "./css/emi.css";
// import { Link } from "@reach/router";
import { useState } from "react";
import CustomModal from "../CustomModal";
import EMIoutstandingPay from "./EmiOutstandingPay";
import EmiDueToPay from "./EmiDueToPay";
import constants from "../../../../Shared/constants/constants";
import swal from "sweetalert";
import emiAbi from "../../../../Shared/emiAbi.json";
// import erc20Abi from "../../assets/block                        chain/erc20Abi.json";
import moment from "moment";
import { images } from "../../../../Shared";
import Web3 from "web3";
import Cookies from "universal-cookie";
import Slider from "react-slick";

const cookies = new Cookies();

const EmiPayment = () => {
	const [showAccordianIconic, setShowAccordianIconic] = useState(true);
	const [showAccordianPremium, setShowAccordianPremium] = useState(true);
	const [showAccordianTop, setShowAccordianTop] = useState(true);
	const [showDueToPayPopup, setShowDueToPayPopup] = useState(false);
	const [showModal, setShowModal] = useState(false);

	const [connectedWallet, setConnectedWallet] = useState(null);
	const [web3, setWeb3] = useState(null);
	const [isWalletConnected, setWalletConnected] = useState(false);
	const [showConnectWallet, setShowConnectWallet] = useState(false);
	const [estimatedRewards, setEstimatedRewards] = useState(0);
	const [outStanding, setOutStanding] = useState(0);
	const [totalNFTsOnEMI, setTotalNFTsOnEMI] = useState(0);
	const [collection1, setCollection1] = useState([]);
	const [collection2, setCollection2] = useState([]);
	const [collection3, setCollection3] = useState([]);
	const [isAlreadyLoded, setIsAlreadyLoaded] = useState(false);
	const [paymentCollection, setPaymentCollection] = useState("");
	const [paymentEmiId, setPaymentEmiId] = useState("");

	const connectToWallet = async () => {
		console.log(`[nft][src][components][pages][EMIPayments][connectToWallet]`);
		if (typeof window.ethereum !== "undefined") {
			let accounts = await window.ethereum.request({
				method: "eth_requestAccounts",
			});
			window.web3 = new Web3(window.ethereum);
			setWeb3(window.web3);

			let chainId = await window.web3.eth.getChainId();
			if (chainId !== parseInt(constants.AVAX_CHAINID)) {
				swal({
					title: "Invalid Network!",
					text: `Switch your network to ${constants.AVAX_NETWORK_NAME}`,
					icon: "error",
					confirmButtonText: "Ok",
				});
				return;
			}
			cookies.set("wallet", accounts[0], { path: "/" });
			cookies.set("wallet_status", true, { path: "/" });
			setWalletConnected(true);
			setConnectedWallet(accounts[0]);
			setWeb3(window.web3);
		} else {
			cookies.set("wallet", null, { path: "/" });
			cookies.set("wallet_status", false, { path: "/" });
			setWalletConnected(false);
			setConnectedWallet("");
			setWeb3(null);
			console.log("Unsupported Browser/Plugin not installed");
			swal({
				icon: "warning",
				title: "Unsupported Browser/Plugin",
				text: "Please install Metamask wallet.",
				closeOnClickOutside: true,
			});
		}
	};

	const getWalletConnectionStatus = async () => {
		let _wallet = cookies.get("wallet");
		let _wallet_status = cookies.get("wallet_status");
		if (_wallet_status == true || _wallet_status == "true") {
			setWalletConnected(true);
			setConnectedWallet(_wallet);
			setWeb3(window.web3);
			await getEMIInfo();
			setIsAlreadyLoaded(true);
		} else {
			setWalletConnected(false);
			setConnectedWallet(null);
			setWeb3(null);
		}
	};

	const disconnectWallet = () => {
		cookies.set("wallet", null, { path: "/" });
		cookies.set("wallet_status", false, { path: "/" });
		setConnectedWallet(null);
		setWalletConnected(false);
		setWeb3(null);
		setShowConnectWallet(true);
		refreshPage();
	};

	const refreshPage = () => {
		window.location.reload();
	};

	const getEMIInfo = async () => {
		console.log(`[nft][src][components][pages][EMIPayments][getEMIInfo]`);

		let web3 = new Web3(window.ethereum);
		if (web3 != null) {
			if (isWalletConnected == true) {
				try {
					let accounts = await web3.eth.getAccounts();
					let wallet = accounts[0];
					let EMI = await new web3.eth.Contract(
						emiAbi,
						constants.NITROMORTGAGE
					);

					let allCollections = [
						constants.COLLECTION1,
						constants.COLLECTION2,
						constants.COLLECTION3,
					];
					console.log(
						`[nft][src][components][pages][EMIPayments][getEMIInfo] Allowed Collections`,
						allCollections
					);

					// rewards calculation
					let _rewards = await EMI.methods
						.calculateRewards(wallet, allCollections)
						.call();
					let _rewardsToShow = await web3.utils.fromWei(
						_rewards.toString(),
						"ether"
					);
					setEstimatedRewards(_rewardsToShow);
					console.log(
						`[nft][src][components][pages][EMIPayments][getEMIInfo] Rewards`,
						_rewardsToShow
					);

					let _totalAmount = 0;

					let userCollection1Count;
					let userCollection2Count;
					let userCollection3Count;

					userCollection1Count = await EMI.methods
						.getNoOfNFTsByCollection(wallet, constants.COLLECTION1)
						.call();
					userCollection2Count = await EMI.methods
						.getNoOfNFTsByCollection(wallet, constants.COLLECTION2)
						.call();
					userCollection3Count = await EMI.methods
						.getNoOfNFTsByCollection(wallet, constants.COLLECTION3)
						.call();

					console.log(
						`[nft][src][components][pages][EMIPayments][getEMIInfo] Collection Count - 1`,
						userCollection1Count
					);
					console.log(
						`[nft][src][components][pages][EMIPayments][getEMIInfo] Collection Count - 2`,
						userCollection2Count
					);
					console.log(
						`[nft][src][components][pages][EMIPayments][getEMIInfo] Collection Count - 3`,
						userCollection3Count
					);

					let userCollection1List = [];
					let userCollection2List = [];
					let userCollection3List = [];

					userCollection1List = await EMI.methods
						.getListOfUserEMIIdsByCollection(wallet, constants.COLLECTION1)
						.call();
					userCollection2List = await EMI.methods
						.getListOfUserEMIIdsByCollection(wallet, constants.COLLECTION2)
						.call();
					userCollection3List = await EMI.methods
						.getListOfUserEMIIdsByCollection(wallet, constants.COLLECTION3)
						.call();

					console.log(
						`[nft][src][components][pages][EMIPayments][getEMIInfo] Collection List - 1`,
						userCollection1List
					);
					console.log(
						`[nft][src][components][pages][EMIPayments][getEMIInfo] Collection List - 2`,
						userCollection2List
					);
					console.log(
						`[nft][src][components][pages][EMIPayments][getEMIInfo] Collection List - 3`,
						userCollection3List
					);

					// let totalNFMs = parseInt(userCollection1Count) + parseInt(userCollection2Count) + parseInt(userCollection3Count);
					// setTotalNFTsOnEMI(totalNFMs)

					// get loan info

					let loanInfo1 = [];
					let loanInfo2 = [];
					let loanInfo3 = [];

					let loanInfo1Team = "";
					let loanInfo2Team = "";
					let loanInfo3Team = "";

					for (let i = 0; i < userCollection1Count; i++) {
						let _amountDue = await EMI.methods
							.getEMIAmountDue(
								wallet,
								constants.COLLECTION1,
								userCollection1List[i]
							)
							.call();

						let __amountDue = _amountDue / 1000000;

						_totalAmount = parseInt(_totalAmount) + parseInt(__amountDue);
						setOutStanding(_totalAmount);

						let _amountPaid = await EMI.methods
							.getListOfUserLoansByCollection(
								wallet,
								constants.COLLECTION1,
								userCollection1List[i]
							)
							.call();
						let __amountPaid = _amountPaid / 1000000;

						let _status = await EMI.methods
							.getEMIStatus(
								wallet,
								constants.COLLECTION1,
								userCollection1List[i]
							)
							.call();

						loanInfo1Team = {
							emiId: userCollection1List[i],
							status: await EMI.methods
								.getEMIStatus(
									wallet,
									constants.COLLECTION1,
									userCollection1List[i]
								)
								.call(),
							amountDue: __amountDue,
							amountPaid: __amountPaid,
							dueTime: await EMI.methods
								.dueTime(wallet, constants.COLLECTION1, userCollection1List[i])
								.call(),
							emiStart: _status,
							collection: constants.COLLECTION1,
						};
						_amountDue = 0;
						__amountDue = 0;
						if (_status == false) {
							loanInfo1.push(loanInfo1Team);
						}
					}
					setCollection1(loanInfo1);

					for (let i = 0; i < userCollection2Count; i++) {
						let _amountDue = await EMI.methods
							.getEMIAmountDue(
								wallet,
								constants.COLLECTION2,
								userCollection2List[i]
							)
							.call();
						let __amountDue = _amountDue / 1000000;

						_totalAmount = parseInt(_totalAmount) + parseInt(__amountDue);
						setOutStanding(_totalAmount);

						let _amountPaid = await EMI.methods
							.getListOfUserLoansByCollection(
								wallet,
								constants.COLLECTION2,
								userCollection2List[i]
							)
							.call();
						let __amountPaid = _amountPaid / 1000000;

						let _status = await EMI.methods
							.getEMIStatus(
								wallet,
								constants.COLLECTION2,
								userCollection2List[i]
							)
							.call();

						loanInfo2Team = {
							emiId: userCollection2List[i],
							status: _status,
							amountDue: __amountDue,
							amountPaid: __amountPaid,
							dueTime: await EMI.methods
								.dueTime(wallet, constants.COLLECTION2, userCollection2List[i])
								.call(),
							emiStart: await EMI.methods
								.userStakedOn(
									wallet,
									constants.COLLECTION2,
									userCollection2List[i]
								)
								.call(),
							collection: constants.COLLECTION2,
						};
						_amountDue = 0;
						__amountDue = 0;
						if (_status == false) {
							loanInfo2.push(loanInfo2Team);
						}
					}
					setCollection2(loanInfo2);

					for (let i = 0; i < userCollection3Count; i++) {
						let _amountDue = await EMI.methods
							.getEMIAmountDue(
								wallet,
								constants.COLLECTION3,
								userCollection3List[i]
							)
							.call();
						let __amountDue = _amountDue / 1000000;

						_totalAmount = parseInt(_totalAmount) + parseInt(__amountDue);
						setOutStanding(_totalAmount);

						let _amountPaid = await EMI.methods
							.getListOfUserLoansByCollection(
								wallet,
								constants.COLLECTION3,
								userCollection3List[i]
							)
							.call();
						let __amountPaid = _amountPaid / 1000000;

						let _status = await EMI.methods
							.getEMIStatus(
								wallet,
								constants.COLLECTION3,
								userCollection3List[i]
							)
							.call();

						loanInfo3Team = {
							emiId: userCollection3List[i],
							status: _status,
							amountDue: __amountDue,
							amountPaid: __amountPaid,
							dueTime: await EMI.methods
								.dueTime(wallet, constants.COLLECTION3, userCollection3List[i])
								.call(),
							emiStart: await EMI.methods
								.userStakedOn(
									wallet,
									constants.COLLECTION3,
									userCollection3List[i]
								)
								.call(),
							collection: constants.COLLECTION3,
						};
						_amountDue = 0;
						__amountDue = 0;
						if (_status == false) {
							loanInfo3.push(loanInfo3Team);
						}
					}
					setCollection3(loanInfo3);

					let totalNFMs =
						parseInt(loanInfo1.length) +
						parseInt(loanInfo2.length) +
						parseInt(loanInfo3.length);
					setTotalNFTsOnEMI(totalNFMs);

					console.log(loanInfo1);
					console.log(loanInfo2);
					console.log(loanInfo3);

					setIsAlreadyLoaded(true);
				} catch (error) {
					console.log(error);
					setIsAlreadyLoaded(true);
				}
			}
		}
	};

	const payEMI = (collection) => {
		setPaymentCollection(collection);
		setShowDueToPayPopup(true);
	};

	const sliderBanner = {
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
	};

	useEffect(() => {
		if (isAlreadyLoded == false) {
			getWalletConnectionStatus();
		}
	});

	return (
		<div className="emi-screen BOX">
			{/* Banner */}
			<div className="marketplace-banner">
				<Slider {...sliderBanner}>
					<a href="https://nft.nitro.network/" target="_blank" rel="noreferrer">
						<img src={images.mintBanner} alt="Banner Markertplace 1" />
					</a>
					<div className="banner-image marketplace-banner">
						<img src={images.bannerMarketplace} alt="Banner 0% Emi" />
					</div>
				</Slider>
			</div>
			{/* <div className="banner-image marketplace-banner">
				<img src={images.bannerMarketplace} alt="Banner 0% Emi" />
			</div> */}

			{/* <a
				href="https://nft.nitro.network/"
				target="_blank"
				rel="noreferrer"
				className="banner-image marketplace-banner"
			>
				<img src={images.mintBanner} alt="Banner 0% Emi" />
			</a> */}

			<div className="nfm-showcase">
				<div className="container">
					<h2 className="text-white mb-4">Choose NFM</h2>
					<div className="nfms">
						<div className="nfm">
							<div className="nfm__image">
								<img src={images.iconicEmi} alt="Tier 1" />
							</div>
							<h3 className="uppercase">Iconic (Tier 1)</h3>
							<p className="nfm__desc">
								You’ll love the way they look and what they stand for. The
								Iconic NFM series represents top location/city tiers, which are
								high-reward hubs on the Nitro Network. They are also cool
								collectibles.
							</p>
							<div className="center  nfm__reward">
								<p className="light mb-0">Ncash Per Epoch</p>
								<p className="light">95.69</p>
							</div>
						</div>
						<div className="nfm">
							<div className="nfm__image">
								<img src={images.premiumEmi} alt="Tier 1" />
							</div>
							<h3 className="uppercase">Premium (Tier 2)</h3>
							<p className="nfm__desc">
								These smoking hot Bots of the Premium NFM series represent Tier
								2 locations and help you mine rewards on our network. And they
								are unique collectibles to have!
							</p>
							<div className="center  nfm__reward">
								<p className="light mb-0">Ncash Per Epoch</p>
								<p className="light">80</p>
							</div>
						</div>
						<div className="nfm">
							<div className="nfm__image">
								<img src={images.emiTier3} alt="Tier 1" />
							</div>
							<h3 className="uppercase">Top (Tier 3)</h3>
							<p className="nfm__desc">
								Inspired by Yoda, these baby Nitro Bots from Tier 3 locations
								are must-haves. They, too, come with rewards and are delightful
								collectibles.
							</p>
							<div className="center nfm__reward">
								<p className="light mb-0">Ncash Per Epoch</p>
								<p className="light">24.18</p>
							</div>
						</div>
					</div>

					{/* <div className="text-center">
						<button
							className="connect-wallet-btn center"
							style={{
								minWidth: "150px",
								textAlign: "center",
								margin: "1rem auto",
							}}
							onClick={() => setShowModal(true)}
						>
							Buy NFM
						</button>
					</div> */}
				</div>
			</div>

			<div className="notification-banner">
				<p>
					MINT OUR NEW NFT COLLECTION - Nitro Bot Army on OPENSEA {"  "}
					<a
						href="https://opensea.io/collection/nitrobotarmy/drop"
						target="_blank"
						rel="noreferrer"
						className="text-underline"
					>
						{" "}
						Visit Now
					</a>
				</p>
			</div>

			{/* TOP ESTIMATE */}

			<div className="emi-section">
				<div className="container">
					<h2 className="text-white">EMI PAYMENT</h2>

					<div className="BOX_LAYOUT">
						<div className="emi-estimate-top">
							<div className="emi-estimate">
								<div>
									<div className="emi-estimate-box dfac dfjb">
										<h3>NFT's On EMI:</h3>
										<h3 className="bold fw-600">{totalNFTsOnEMI}</h3>
									</div>
									<div className="emi-estimate-box">
										<div className="dfjb dfac">
											<h3>Outstanding Amount:</h3>
											<h3 className="bold fw-600">$ {outStanding}</h3>
										</div>
										<div className="text-right">
											{/*OnClick -> EmiOutstandingPay.js Screen  */}
											{/* {isWalletConnected == false && (
                                                <button
                                                    className="gradient-butto-2 fw-600 connect-wallet-btn"
                                                    onClick={connectToWallet}
                                                >
                                                    Connect Wallet
                                                </button>
                                            )} */}

											{/* Why do you need button here? */}
											{/* {isWalletConnected == true && (
                                                <button
                                                    className="gradient-butto-2 fw-600 connect-wallet-btn mb-4"
                                                    onClick={() =>
                                                        setShowDueToPayPopup(
                                                            true
                                                        )
                                                    }
                                                >
                                                    Pay EMI Amount
                                                </button>
                                            )} */}

											{/* <br></br>

                                            {isWalletConnected == true && (
                                                <button
                                                    className="gradient-butto-2 fw-600 connect-wallet-btn bgnull bordered-button"
                                                    style={{
                                                        background:
                                                            "transparent",
                                                        border: "1px solid #fee",
                                                    }}
                                                    onClick={disconnectWallet}
                                                >
                                                    Disconnect Wallet
                                                </button>        
                                            )} */}
										</div>
									</div>
								</div>

								<div className="emi-estimate-box grid-center">
									<p className="light mb-0">Estimated Rewards</p>
									<p className="bold fw-900 fz-big mb-0">
										{estimatedRewards} Ncash
									</p>
								</div>
							</div>
						</div>

						{/* EMI ACCORDIAN  */}
						<div className="emi-all-tier">
							{/* For IConic */}
							<div className="emi-accordian">
								<div
									className="emi-accordian-button emi-estimate-box dfac dfjb"
									onClick={() => setShowAccordianIconic(!showAccordianIconic)}
								>
									<h5 className="mb-0">Iconic</h5>
									<h5 className="mb-0">
										<i className="fa-solid fa-caret-down"></i>
									</h5>
								</div>

								<div
									// className="emi-accordian-content"
									className={`emi-accordian-content ${
										showAccordianIconic ? "" : "collapsed"
									}`}
								>
									<table className="table de-table table-rank table-font-size-reduce table-responsive">
										<thead>
											<tr>
												<th scope="col" className="right">
													S No.
												</th>

												<th scope="col" className="right">
													EMI id
												</th>

												<th scope="col" className="right">
													EMI Paid
												</th>

												<th scope="col" className="right">
													Outstanding
												</th>

												{/* <th scope="col" className="right">
                          EMI Start date (UTC)
                        </th> */}

												<th scope="col" className="right">
													Due Date (UTC)
												</th>

												<th scope="col" className="right"></th>
											</tr>
										</thead>
										<tbody>
											{collection1.map((collection, i) => (
												<tr key={i}>
													<td scope="row" data-label="S No.">
														<span className="address-text-table">
															{i + 1} {/* {capitalize(item?.source)} */}
														</span>
													</td>
													{/* <!-- added class --> */}
													<td className="right" data-label="EMI id">
														{collection.emiId}
													</td>
													{/* <td className="d-plus right" data-label="lat">{item.source}</td> */}
													<td
														className="d-plus right overflow-text"
														data-label="EMI Paid"
													>
														<span className="trx-id">
															$ {collection.amountPaid}{" "}
														</span>
													</td>
													<td
														className="right max-time"
														data-label="Outstanding"
													>
														<span className="time-font">
															{/* {moment(item.createdAt).format(
                                  "DD-MMMM-YYYY hh:mm:ss A"
                              )} */}
															$ {collection.amountDue}
														</span>
													</td>
													{/* <td className="right" data-label="EMI Start Date">
                                                            {moment
                                                            .unix(collection.emiStart)
                                                            .format("DD-MMM-YYYY hh:mm:ss A")}
                                                        </td> */}
													<td className="right" data-label="Due Date">
														{moment
															.unix(collection.dueTime)
															.format("DD-MMM-YYYY hh:mm:ss A")}
													</td>
													<td className="right" data-label="Pay">
														{/* {item.payment_status} */}

														{/*OnClick -> EmiDueToPay.js Screen  */}

														<button
															className="gradient-butto-2 mt-0 cust-padding connect-wallet-btn"
															onClick={() => payEMI(collection)}
														>
															Pay Now
														</button>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
							{/* For Premium */}
							<div className="emi-accordian ">
								<div
									className="emi-accordian-button emi-estimate-box dfac dfjb"
									onClick={() => setShowAccordianPremium(!showAccordianPremium)}
								>
									<h5 className="mb-0">Premium</h5>
									<h5 className="mb-0">
										<i className="fa-solid fa-caret-down"></i>
									</h5>
								</div>

								<div
									className={`emi-accordian-content ${
										showAccordianPremium ? "" : "collapsed"
									}`}
								>
									<table className="table de-table table-rank table-font-size-reduce table-responsive">
										<thead>
											<tr>
												<th scope="col" className="right">
													S No.
												</th>

												<th scope="col" className="right">
													EMI id
												</th>

												<th scope="col" className="right">
													EMI Paid
												</th>

												<th scope="col" className="right">
													Outstanding
												</th>

												{/* <th scope="col" className="right">
                          EMI Start date (UTC)
                        </th> */}

												<th scope="col" className="right">
													Due Date
												</th>

												<th scope="col" className="right"></th>
											</tr>
										</thead>
										<tbody>
											{collection2.map((collection, i) => (
												<tr key={i}>
													<td scope="row" data-label="S No.">
														<span className="address-text-table">
															{i + 1} {/* {capitalize(item?.source)} */}
														</span>
													</td>
													{/* <!-- added class --> */}
													<td className="right" data-label="EMI id">
														{collection.emiId}
													</td>
													{/* <td className="d-plus right" data-label="lat">{item.source}</td> */}
													<td
														className="d-plus right overflow-text"
														data-label="EMI Paid"
													>
														<span className="trx-id">
															$ {collection.amountPaid}
														</span>
													</td>
													<td
														className="right max-time"
														data-label="Outstanding"
													>
														<span className="time-font">
															{/* {moment(item.createdAt).format(
                                  "DD-MMMM-YYYY hh:mm:ss A"
                              )} */}
															$ {collection.amountDue}
														</span>
													</td>
													{/* <td className="right" data-label="EMI Start Date">
                            {moment
                              .unix(collection.emiStart)
                              .format("DD-MMM-YYYY hh:mm:ss A")}
                          </td> */}
													<td className="right" data-label="Due Date">
														{moment
															.unix(collection.dueTime)
															.format("DD-MMM-YYYY hh:mm:ss A")}
													</td>
													<td className="right" data-label="Pay">
														{/* {item.payment_status} */}

														{/*OnClick -> EmiDueToPay.js Screen  */}

														<button
															className="gradient-butto-2 mt-0 cust-padding connect-wallet-btn"
															onClick={() => payEMI(collection)}
														>
															Pay Now
														</button>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
							{/* For Top */}
							<div className="emi-accordian ">
								<div
									className="emi-accordian-button emi-estimate-box dfac dfjb"
									onClick={() => setShowAccordianTop(!showAccordianTop)}
								>
									<h5 className="mb-0">Top</h5>
									<h5 className="mb-0">
										<i className="fa-solid fa-caret-down"></i>
									</h5>
								</div>

								<div
									className={`emi-accordian-content ${
										showAccordianTop ? "" : "collapsed"
									}`}
								>
									<table className="table de-table table-rank table-font-size-reduce table-responsive">
										<thead>
											<tr>
												<th scope="col" className="right">
													S No.
												</th>

												<th scope="col" className="right">
													EMI id
												</th>

												<th scope="col" className="right">
													EMI Paid
												</th>

												<th scope="col" className="right">
													Outstanding
												</th>

												{/* <th scope="col" className="right">
                          EMI Start date (UTC)
                        </th> */}

												<th scope="col" className="right">
													Due Date
												</th>

												<th scope="col" className="right"></th>
											</tr>
										</thead>
										<tbody>
											{collection3.map((collection, i) => (
												<tr key={i}>
													<td scope="row" data-label="S No.">
														<span className="address-text-table">
															{i + 1} {/* {capitalize(item?.source)} */}
														</span>
													</td>
													{/* <!-- added class --> */}
													<td className="right" data-label="EMI id">
														{collection.emiId}
													</td>
													{/* <td className="d-plus right" data-label="lat">{item.source}</td> */}
													<td
														className="d-plus right overflow-text"
														data-label="EMI Paid"
													>
														<span className="trx-id">
															$ {collection.amountPaid}{" "}
														</span>
													</td>
													<td
														className="right max-time"
														data-label="Outstanding"
													>
														<span className="time-font">
															{/* {moment(item.createdAt).format(
                                  "DD-MMMM-YYYY hh:mm:ss A"
                              )} */}
															$ {collection.amountDue}
														</span>
													</td>
													{/* <td className="right" data-label="EMI Start Date">
                            {moment
                              .unix(collection.emiStart)
                              .format("DD-MMM-YYYY hh:mm:ss A")}
                          </td> */}
													<td className="right" data-label="Due Date">
														{moment
															.unix(collection.dueTime)
															.format("DD-MMM-YYYY hh:mm:ss A")}
													</td>
													<td className="right" data-label="Pay">
														{/* {item.payment_status} */}

														{/*OnClick -> EmiDueToPay.js Screen  */}

														<button
															className="gradient-butto-2 mt-0 cust-padding connect-wallet-btn"
															onClick={() => payEMI(collection)}
														>
															Pay Now
														</button>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div>
							<ol>
								<li
									style={{
										listStyle: "auto",
										paddingLeft: "10px",
										marginLeft: "20px",
									}}
								>
									NFMs purchased using EMI are auto-staked with respective tier
									rewards per epoch.
								</li>
								<li
									style={{
										listStyle: "auto",
										paddingLeft: "10px",
										marginLeft: "20px",
									}}
								>
									A minimum 10% payment is required to be made to initiate the
									EMI process per NFM, per tier independent to NFM tier.
								</li>
								<li
									style={{
										listStyle: "auto",
										paddingLeft: "10px",
										marginLeft: "20px",
									}}
								>
									Ncash rewards per epoch are accumulated on the contract and
									will be automatically transferred to the wallet once the full
									payment on the NFMs purchased is/are done.
								</li>
								<li
									style={{
										listStyle: "auto",
										paddingLeft: "10px",
										marginLeft: "20px",
									}}
								>
									NFM is not minted unless the amount is fully paid.
								</li>
								<li
									style={{
										listStyle: "auto",
										paddingLeft: "10px",
										marginLeft: "20px",
									}}
								>
									If the NFM (paid for with EMI plan), is not fully paid within
									100 days from the date of purchase, there will be no minting
									and such users will not be able to claim rewards and no refund
									will be provided for the paid amount.
								</li>
							</ol>
						</div>
					</div>
				</div>
			</div>

			{/*Popup for BUY NFM BUTTON  */}
			{isWalletConnected ? (
				<>
					{/* Popup for outstanding  */}
					<CustomModal
						showModal={showModal}
						toggleModalView={() => setShowModal(!showModal)}
						isfromEmi={true}
					>
						<EMIoutstandingPay />
					</CustomModal>
				</>
			) : (
				<CustomModal
					showModal={showModal}
					toggleModalView={() => setShowModal(!showModal)}
					isfromEmi={true}
				>
					<div className="text-center center">
						<p className="center">Please Connect your Wallet to Continue!</p>
						<div className="text-center">
							<button
								className="connect-wallet-btn"
								onClick={() => setShowModal(false)}
							>
								{" "}
								OK{" "}
							</button>
						</div>
					</div>
				</CustomModal>
			)}

			{/* POPUP FOR INDIVIDIUAL */}
			{isWalletConnected ? (
				<>
					{/* Popup for Due to Pay  */}
					<CustomModal
						showModal={showDueToPayPopup}
						toggleModalView={() => setShowDueToPayPopup(!showDueToPayPopup)}
						isfromEmi={true}
					>
						<EmiDueToPay collectionInfo={paymentCollection} />
					</CustomModal>
				</>
			) : (
				<CustomModal
					showModal={showModal}
					toggleModalView={() => setShowModal(!showModal)}
					isfromEmi={true}
				>
					<div className="text-center center">
						<p className="center">Please Connect your Wallet to Continue!</p>
						<div className="text-center">
							<button
								className="connect-wallet-btn"
								onClick={() => setShowModal(false)}
							>
								{" "}
								OK{" "}
							</button>
						</div>
					</div>
				</CustomModal>
			)}

			{/* {showOutstandingPopup ? <EMIoutstandingPay /> : null} */}
		</div>
	);
};

export default EmiPayment;
